/** F&CO 쇼룸 출고 신청(209) — EAS 요청번호만 품의에 연결, 본문은 일반 에디터 */
export const FNCO_SHOW_ROOM_TYPE = 209;

export const isFncoShowRoomType = (apvType: number): boolean =>
  apvType === FNCO_SHOW_ROOM_TYPE;

/** EAS → 작성 화면 진입 쿼리 키 — 레거시 `/intranet/approval/create?apv_type=209&reqno=` 와 동일 */
export const FNCO_SHOW_ROOM_ENTRY_QUERY_KEY = 'reqno';

export const FNCO_SHOW_ROOM_MISSING_MESSAGE =
  '데이터의 request number가 존재하지 않습니다. reqno를 다시 확인해주세요.';

/** 진입 쿼리 → 요청번호. 반복 키는 첫 값, 공백만 있으면 없음 */
export const getEntryRequestNumber = (
  query: Record<string, string | string[] | undefined>,
): string | undefined => {
  const raw = query[FNCO_SHOW_ROOM_ENTRY_QUERY_KEY];
  const value = (Array.isArray(raw) ? raw[0] : raw)?.trim();
  return value || undefined;
};

/** 저장 attributes → 요청번호. 레거시 문서(VC001 없음)는 attributes 가 null */
export const parseFncoShowRoomRequestNumber = (
  attributes: Record<string, unknown> | null | undefined,
): string | null => {
  const value = attributes?.requestNumber;
  return typeof value === 'string' && value.trim() ? value.trim() : null;
};

export const buildFncoShowRoomAttributes = (requestNumber: string | null) =>
  requestNumber ? { requestNumber } : null;
